import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=fc221c0c&scoped=true&"
import script from "./contentBox.vue?vue&type=script&lang=js&"
export * from "./contentBox.vue?vue&type=script&lang=js&"
import style0 from "./contentBox.vue?vue&type=style&index=0&id=fc221c0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc221c0c",
  null
  
)

export default component.exports